export function saveSearchedTerms(terms: string) {
  const existingTerms = localStorage?.getItem('searchedTerms')
    ? JSON.parse(localStorage.getItem('searchedTerms') as string)
    : []

  if (
    existingTerms?.some(
      (existingTerm: { term: string }) => existingTerm?.term === terms.trim()
    )
  ) {
    return
  }

  localStorage.setItem(
    'searchedTerms',
    JSON.stringify([...existingTerms, { term: terms }])
  )
}
